export default function fetchDispenseStatement(filterParams: URLSearchParams, init?: RequestInit) {

  return fetch('/your-orders-api/command/dispense-statement?' + filterParams.toString(), {
    method: 'GET',
    credentials: 'same-origin',
    redirect: 'manual',
    ...init
  });
}
